import { MediaAnalysisProgress, MediaAnalysisStatus } from '@/common/model/media/mediaAnalysis'

export const CompetitorSerpApiPath = {
  RUN_COMPETITOR_SERP: '/api/sites/{site_id}/competitor-serp/run', // POST Run Competitor Serp（バックグラウンド実行）
  GET_SERP_HISTORY_DETAIL: '/api/sites/{site_id}/competitor-serp/history/{history_id}' // GET Get Serp History Detail
}

export type CompetitorSerpApiPath =
  (typeof CompetitorSerpApiPath)[keyof typeof CompetitorSerpApiPath]

export interface GetSerpHistoryDetailVars {
  site_id: number
  history_id: number
}

// バックグラウンド実行の入力。分析対象（media_analysis_target_id）から入力を解決する
export interface RunCompetitorSerpVars {
  site_id: number
  media_analysis_target_id?: number | null
  target_domain?: string
  competitor_domains?: string[]
  keywords?: string[]
  keyword_seed?: string | null
  max_keywords?: number
}

export interface RunCompetitorSerpResponse {
  id: number
  analysis_type: string
  status: string // analyzing
}

export interface GetSerpHistoryDetailResponse {
  id: number
  input_data: Record<string, unknown>
  result_data: Record<string, unknown>
  summary: string | null
  status?: MediaAnalysisStatus
  progress?: MediaAnalysisProgress
  created_at: string | null
}
